import styled from "styled-components";
import { SPACING } from "../../../utils/constants";

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.xxl + SPACING.sm + SPACING.xs}px
    ${SPACING.md + SPACING.xs}px;
  text-align: center;
  background: var(--gradient-error);
  border-radius: 12px;
  border: 1px solid var(--color-error-border-2);
  margin: ${SPACING.md}px;

  h3 {
    margin: 0 0 ${SPACING.sm}px 0;
    color: var(--color-error);
    font-size: var(--text-xl);
    font-weight: 600;
  }

  p {
    margin: 0 0 ${SPACING.md + SPACING.xs}px 0;
    color: var(--color-error2);
    font-size: var(--text-md);
    max-width: 400px;
    line-height: 1.5;
  }
`;
